import React, { useState, useEffect, ReactElement } from "react";
import Alert from "./icons/Alert";
import Loading from "./Loading";

type PopUpOptions = {
  width?: string;
  closeOnEsc?: boolean;
};

let overlayContent = null;
let popupWidth = "320px";
let closeOnEsc = false;
let callbacks: Function[] = [];
let value = 0;

export function showPopUp(content, options?: PopUpOptions) {
  overlayContent = content;
  popupWidth = options ? options.width || "320px" : "320px";
  closeOnEsc =
    options && typeof options["closeOnEsc"] !== "undefined"
      ? options.closeOnEsc
      : false;
  callbacks.forEach((c) => c(++value));
}
export function showLoadingPopUp(message: string) {
  showPopUp(
    <>
      <div className="center">
        <Loading />
      </div>
      <p className="tac mt1">{message}</p>
    </>
  );
}
export function showAlertPopUp(
  message: Element | ReactElement | string,
  width: string = "320px"
) {
  showPopUp(
    <>
      <div className="center">
        <Alert size={50} />
      </div>
      <p className="tac mt1 mb1">{message}</p>
      <div className="center">
        <button className="secondary" onClick={closePopUp}>
          Close
        </button>
      </div>
    </>,
    { width }
  );
}
export function closePopUp() {
  overlayContent = null;
  closeOnEsc = false;
  callbacks.forEach((c) => c(++value));
}

export default function Overlay() {
  const [i, rerender] = useState(value);
  useEffect(() => {
    const c = (value) => {
      rerender(value);
    };
    const onEscPress = (e) => {
      if (closeOnEsc && overlayContent && e.keyCode === 27) {
        closePopUp();
      }
    };
    callbacks.push(c);
    // @ts-ignore
    document.querySelector("body").addEventListener("keyup", onEscPress);
    return () => {
      callbacks = callbacks.filter((cb) => cb !== c);
      document.querySelector("body")?.removeEventListener("keyup", onEscPress);
    };
  }, []);
  if (!overlayContent) {
    return null;
  }

  return (
    <div className="overlay center" key={i}>
      <div className="popup" style={{ width: popupWidth }}>
        {overlayContent}
      </div>
    </div>
  );
}
